import * as React from "react";
import { JSX } from "react/jsx-runtime";
const TurnoverIcon = ({
  color = "#fff",
  ...props
}: JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8627 7.67759C13.0254 7.53809 13.1068 7.46835 13.1366 7.38535C13.1628 7.3125 13.1628 7.23281 13.1366 7.15996C13.1068 7.07696 13.0254 7.00722 12.8627 6.86772L7.21554 2.0273C6.93538 1.78717 6.79531 1.66711 6.67671 1.66417C6.57364 1.66161 6.47519 1.70689 6.41006 1.78681C6.33511 1.87877 6.33511 2.06326 6.33511 2.43224V5.29574C4.91199 5.54471 3.60951 6.26583 2.64159 7.34857C1.58633 8.529 1.0026 10.0566 1.00178 11.64V12.048C1.70134 11.2052 2.57478 10.5237 3.56228 10.0499C4.43291 9.63227 5.37406 9.38487 6.33511 9.31967V12.1131C6.33511 12.4821 6.33511 12.6665 6.41006 12.7585C6.47519 12.8384 6.57364 12.8837 6.67671 12.8811C6.79531 12.8782 6.93538 12.7581 7.21554 12.518L12.8627 7.67759Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TurnoverIcon;
